import { CardSystem } from 'app/dataTypes/acquiring/recurrent/cards'

import Mastercard from './svg/mastercard.svg'
import Visa from './svg/visa.svg'
import Mir from './svg/mir.svg'
import Union from './svg/union.svg'

type Props = {
  className?: string
  system: CardSystem
}

export const CardSystemIcon = ({ className, system }: Props) => {
  if (system === CardSystem.Mastercard) return <Mastercard className={className} height={16} />
  if (system === CardSystem.Visa) return <Visa className={className} height={12} />
  if (system === CardSystem.Mir) return <Mir className={className} height={12} />
  if (system === CardSystem.Unionpay) return <Union className={className} height={16} />

  return null
}
